export default "__VITE_ASSET__54aa5d04__"